// This file is auto-generated by @hey-api/openapi-ts

import type { Client, Options as Options2, TDataShape } from './client';
import { client } from './client.gen';
import type { CreateSiteV2Data, CreateSiteV2Errors, CreateSiteV2Responses, DownloadPhotoData, DownloadPhotoResponses, GetApiApplianceTypeData, GetApiApplianceTypeErrors, GetApiApplianceTypeResponses, GetPhotosListData, GetPhotosListResponses, GetSiteV2Data, GetSiteV2Errors, GetSiteV2Responses, PatchApplianceData, PatchApplianceErrors, PatchApplianceResponses, ReplaceSiteAddressV2Data, ReplaceSiteAddressV2Errors, ReplaceSiteAddressV2Responses, UpdateSiteAddressV2Data, UpdateSiteAddressV2Errors, UpdateSiteAddressV2Responses, UpdateSiteV2Data, UpdateSiteV2Errors, UpdateSiteV2Responses } from './types.gen';
import { zCreateSiteV2Response, zDownloadPhotoResponse, zGetApiApplianceTypeResponse, zGetPhotosListResponse, zGetSiteV2Response, zReplaceSiteAddressV2Response, zUpdateSiteAddressV2Response, zUpdateSiteV2Response } from './zod.gen';

export type Options<TData extends TDataShape = TDataShape, ThrowOnError extends boolean = boolean> = Options2<TData, ThrowOnError> & {
    /**
     * You can provide a client instance returned by `createClient()` instead of
     * individual options. This might be also useful if you want to implement a
     * custom client.
     */
    client?: Client;
    /**
     * You can pass arbitrary values through the `meta` object. This can be
     * used to access values that aren't defined as part of the SDK function.
     */
    meta?: Record<string, unknown>;
};

/**
 * Retrieve a site by id
 */
export const getSiteV2 = <ThrowOnError extends boolean = false>(options: Options<GetSiteV2Data, ThrowOnError>) => (options.client ?? client).get<GetSiteV2Responses, GetSiteV2Errors, ThrowOnError>({
    responseValidator: async (data) => await zGetSiteV2Response.parseAsync(data),
    url: '/api/site/v2/{siteId}',
    ...options
});

/**
 * Update a site with a given id
 */
export const updateSiteV2 = <ThrowOnError extends boolean = false>(options: Options<UpdateSiteV2Data, ThrowOnError>) => (options.client ?? client).put<UpdateSiteV2Responses, UpdateSiteV2Errors, ThrowOnError>({
    responseValidator: async (data) => await zUpdateSiteV2Response.parseAsync(data),
    url: '/api/site/v2/{siteId}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Create a site
 */
export const createSiteV2 = <ThrowOnError extends boolean = false>(options: Options<CreateSiteV2Data, ThrowOnError>) => (options.client ?? client).post<CreateSiteV2Responses, CreateSiteV2Errors, ThrowOnError>({
    responseValidator: async (data) => await zCreateSiteV2Response.parseAsync(data),
    url: '/api/site/v2',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Partially update a site address V2
 */
export const updateSiteAddressV2 = <ThrowOnError extends boolean = false>(options: Options<UpdateSiteAddressV2Data, ThrowOnError>) => (options.client ?? client).patch<UpdateSiteAddressV2Responses, UpdateSiteAddressV2Errors, ThrowOnError>({
    responseValidator: async (data) => await zUpdateSiteAddressV2Response.parseAsync(data),
    url: '/api/site/v2/{siteId}/address',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Fully replace a site address V2
 */
export const replaceSiteAddressV2 = <ThrowOnError extends boolean = false>(options: Options<ReplaceSiteAddressV2Data, ThrowOnError>) => (options.client ?? client).put<ReplaceSiteAddressV2Responses, ReplaceSiteAddressV2Errors, ThrowOnError>({
    responseValidator: async (data) => await zReplaceSiteAddressV2Response.parseAsync(data),
    url: '/api/site/v2/{siteId}/address',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get the site's installation photos
 */
export const getPhotosList = <ThrowOnError extends boolean = false>(options: Options<GetPhotosListData, ThrowOnError>) => (options.client ?? client).get<GetPhotosListResponses, unknown, ThrowOnError>({
    responseValidator: async (data) => await zGetPhotosListResponse.parseAsync(data),
    url: '/api/site/{siteId}/photosList',
    ...options
});

/**
 * Download a photo
 */
export const downloadPhoto = <ThrowOnError extends boolean = false>(options: Options<DownloadPhotoData, ThrowOnError>) => (options.client ?? client).get<DownloadPhotoResponses, unknown, ThrowOnError>({
    responseValidator: async (data) => await zDownloadPhotoResponse.parseAsync(data),
    url: '/api/photos/{publicPhotoId}',
    ...options
});

/**
 * Retrieve a list of appliance type
 *
 * Returns a list of appliance type.
 */
export const getApiApplianceType = <ThrowOnError extends boolean = false>(options?: Options<GetApiApplianceTypeData, ThrowOnError>) => (options?.client ?? client).get<GetApiApplianceTypeResponses, GetApiApplianceTypeErrors, ThrowOnError>({
    responseValidator: async (data) => await zGetApiApplianceTypeResponse.parseAsync(data),
    url: '/api/appliance/type',
    ...options
});

/**
 * Update appliance type and localisation
 */
export const patchAppliance = <ThrowOnError extends boolean = false>(options: Options<PatchApplianceData, ThrowOnError>) => (options.client ?? client).patch<PatchApplianceResponses, PatchApplianceErrors, ThrowOnError>({
    url: '/api/appliance/{csApplianceId}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});
